import { InfoWindowF, MarkerF } from "@react-google-maps/api";
import React, { memo } from "react";

const styles = {
  labelStyle: {
    textAlign: "center",
    backgroundColor: "#343a40",
  },
};

// const styles = {
//   labelStyle: {
//     position: "absolute",
//     textAlign: "center",
//     width: "420px",
//     backgroundColor: "#343a40",
//     bottom: 10,
//     left: -59,
//     padding: "3px 4px",
//     color: "white",
//     fontSize: "12px",
//     borderRadius: "4px",
//   },
// };
const DisplayMarkerWithLabel = ({
  location,
  showMarkerLabel,
  clusterer,
  Highlight = false,
  selectMarker,
  polyLineMarker,
  locationCount,
}) => {
  const getMarkerIcon = () => {
    const dir_angle = (location?.Heading * 360) / 256;
    let dashPins = "/assets/img/newicon/top-arrow-black-v2-0.png";
    let pinColor = "black";
    let pinDirection = "0";

    if (location?.Ignition === "False") {
      pinColor = "black";
    } else if (
      location.Ignition === "True" &&
      (location.Speed === "" || location.Speed === "0")
    ) {
      pinColor = "orange";
    } else {
      pinColor = "blue";
    }

    if (dir_angle === 0 || dir_angle === 360) {
      pinDirection = "0";
    } else if (dir_angle === 90) {
      pinDirection = "6";
    } else if (dir_angle === 180) {
      pinDirection = "4";
    } else if (dir_angle === 270) {
      pinDirection = "2";
    } else if (dir_angle > 0 && dir_angle < 90) {
      pinDirection = "7";
    } else if (dir_angle > 90 && dir_angle < 180) {
      pinDirection = "5";
    } else if (dir_angle > 180 && dir_angle < 270) {
      pinDirection = "3";
    } else if (dir_angle > 270 && dir_angle < 360) {
      pinDirection = "1";
    }

    //Check if trip based history
    if (Highlight || polyLineMarker) {
      dashPins =
        "/assets/img/direction-v2/arrow-v2-" +
        pinColor +
        "-20-" +
        pinDirection +
        ".png";
    } else {
      dashPins =
        "/assets/img/newicon/top-arrow-" +
        pinColor +
        "-v2-" +
        pinDirection +
        ".png";
    }

    if (location.Status === 0) {
      dashPins = "/assets/img/history-icons/trip-start-30.png";
    } else if (location.Status === 2) {
      dashPins = "/assets/img/history-icons/trip-end-30.png";
    }

    return {
      url: dashPins,
      size: new window.google.maps.Size(30, 30),
      origin: new window.google.maps.Point(0, 0),
      anchor: new window.google.maps.Point(12, 12),
      zIndex: 100,
    };
  };
  const markerPosition = {
    lat: Number(parseFloat(location?.Latitude)),
    lng: Number(parseFloat(location?.Longitude)),
  };

  if (Number(location?.Latitude) === 0 && Number(location?.Longitude) === 0)
    return null;

  const markerLabel = () => {
    if (clusterer && locationCount <= 5)
      return (
        <InfoWindowF
          options={{
            backgroundColor: "red",
          }}
          style={styles.labelStyle}
          position={{
            lat: Number(parseFloat(location?.Latitude)),
            lng: Number(parseFloat(location?.Longitude)),
          }}
        >
          <>
            <div
              style={{
                position: "relative",
                fontSize: 10,
                fontWeight: "bold",
                color: "black",
              }}
            >{`${location.VehiclePlate} - ${location.VehicleCode}`}</div>
          </>
        </InfoWindowF>
      );
  };

  if (showMarkerLabel) {
    return (
      <>
        <MarkerF
          position={markerPosition}
          clusterer={clusterer}
          icon={getMarkerIcon()}
          onClick={() => selectMarker(location)}
        >
          {markerLabel()}
        </MarkerF>
      </>
    );
  } else {
    return (
      <MarkerF
        position={{
          lat: Number(parseFloat(location?.Latitude)),
          lng: Number(parseFloat(location?.Longitude)),
        }}
        clusterer={clusterer}
        icon={getMarkerIcon()}
        onClick={() => selectMarker(location)}
      />
    );
  }
};

export default memo(DisplayMarkerWithLabel);
